import { z } from "zod";
import { normalizeCidr } from "./lib/cidr";
import { API_SCOPE_VALUES, ORG_SCOPE_VALUES } from "./scopes";

export { normalizeCidr } from "./lib/cidr";
export {
	API_SCOPES,
	type ApiScope,
	type ApiScopeOption,
	hasScope,
	ORG_SCOPE_VALUES,
	ORG_SCOPES,
} from "./scopes";

export const ApiScopeSchema = z.enum(API_SCOPE_VALUES);
/** What an organization key may be granted (no partner scopes). */
export const OrgApiScopeSchema = z.enum(ORG_SCOPE_VALUES);

export const CIDR_HINT =
	"Enter an IP address or a range, like 203.0.113.7 or 203.0.113.0/24";

/** One IP allow-list entry. Normalized on the server with normalizeCidr. */
export const cidrSchema = z
	.string()
	.trim()
	.refine((value) => normalizeCidr(value) !== null, CIDR_HINT);

/** Entries in one key's IP allow-list. */
export const MAX_ALLOWED_IPS = 50;

/** Empty means any address. */
export const allowedIpsSchema = z.array(cidrSchema).max(MAX_ALLOWED_IPS);
